export const getFormData = (form) => {
  if (!(form instanceof HTMLFormElement)) {
    throw new Error("Переданный элемент не является формой!");
  }

  const formData = new FormData(form);

  // Добавляем UTM-метки из localStorage
  const utmData = JSON.parse(localStorage.getItem("utm_data")) || {};

  Object.entries(utmData).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return formData;
};
